var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.4062C11.314 14.4062 14.4062 11.314 14.4062 7.5C14.4063 3.68596 11.314 0.59375 7.5 0.59375C3.68596 0.59375 0.59375 3.68596 0.59375 7.5C0.59375 11.314 3.68596 14.4062 7.5 14.4062ZM6.3276 4.68803C6.27619 4.63919 6.23508 4.58055 6.20669 4.51557C6.1783 4.45059 6.16321 4.38059 6.1623 4.30968C6.16139 4.23878 6.17469 4.16841 6.2014 4.10273C6.22812 4.03704 6.26772 3.97737 6.31786 3.92723C6.368 3.87709 6.42767 3.8375 6.49335 3.81078C6.55904 3.78406 6.62941 3.77077 6.70031 3.77168C6.77121 3.77258 6.84122 3.78768 6.9062 3.81607C6.97117 3.84445 7.02981 3.88556 7.07865 3.93697L10.2662 7.12447C10.3657 7.22409 10.4216 7.35916 10.4216 7.5C10.4216 7.64084 10.3657 7.77591 10.2662 7.87553L7.07865 11.063C6.97821 11.1585 6.84447 11.2109 6.70594 11.2091C6.56741 11.2073 6.43506 11.1515 6.33709 11.0535C6.23913 10.9556 6.18331 10.8232 6.18154 10.6847C6.17976 10.5462 6.23217 10.4124 6.3276 10.312L9.13924 7.5L6.3276 4.68803Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorRight);
export default __webpack_public_path__ + "static/media/vector-right.b9778bc570f5eff2551c11d7b0512f53.svg";
export { ForwardRef as ReactComponent };